import { Box, Flex, Image, Text } from '@chakra-ui/react';

const Footer = () => {
  return (
    <Box
      as="footer"
      bg="white"
      py={3}
      width="100%"
      borderTop="1px solid"
      borderColor="gray.100"
    >
      <Flex align="center" justify="center" gap={3}>
        <Text fontSize="xs" color="muted.400" fontWeight="medium">
          Developed by
        </Text>
        <Image
          src="/images/UGenomeHorizontalBlue.png"
          alt="UGENOME AI Logo"
          height="40px"
          width="auto"
          objectFit="contain"
          opacity={0.9}
        />
      </Flex>
    </Box>
  );
};

export default Footer;
